import Service from '@ember/service';
import $ from 'jquery';
import Em from 'ember';
export default Service.extend({
  ajax(url, method, data) {
    return new Em.RSVP.Promise((resolve, reject) => {
      $.ajax({
        url,
        method,
        data
      }).done(resolve).fail(reject);
    });
  }
});